 export enum AccountType {
    Free = "free",
    Premium = "premium"
}
